import vue from "vue";

export default {
    SET_TITLE: (state, title) => {
        state.title = title;
    },
    SET_CITIES: (state, cities) => {
        state.cities = cities;
    },
    SET_ISSUED_CITIES: (state, issuedCities) => {
        state.issuedCities = issuedCities;
    },
    SET_BIRTH_CITIES: (state, birthCities) => {
        state.birthCities = birthCities;
    },
    SET_CITY: (state, city) => {
        state.city = city;
    },
    SET_PROVINCE: (state, province) => {
        state.province = province;
    },
    SET_STATUS: (state, status) => {
        state.status = status;
    },
    SET_CITY_TO_EDIT: (state, cityToEdit) => {
        state.cityToEdit = cityToEdit;
    },
    SET_TOTAL: (state, total) =>{
        state.total = total
    },
}